import React, {Component} from "react";
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { APIProvider, Map, AdvancedMarker } from '@vis.gl/react-google-maps';

// 38.22172640168092, -85.68285793709502
// mapId 80e7842ff8ce0d0cb59d059f
const position = { lat: 38.22172640168092, lng: -85.68285793709502};
const apiKey = 'AIzaSyCmriz-E929QgmgGmeIkQDzWk77ctg2tuc';	

class Contact extends Component {
		
    constructor() {
        super();
        this.state = {
            content: null,
            contactModalShow: false,
      		contactModalText: "Got It!"
        };
        
        this.showModal = this.showContactModal.bind(this);
    	this.hideModal = this.hideContactModal.bind(this);
    }
    
	showContactModal = () => {
    	this.setState({ contactModalShow: true });
  	};

  	hideContactModal = () => {
    	this.setState({ contactModalShow: false });
  	};
  
  	textContactModal = (modaltext) => {
    	this.setState({ contactModalText: modaltext });
    
    	this.setState({ contactModalShow: true });
  	};
  	
  	
  	contactEventHandler = (event) => {
			
		event.preventDefault();
			
		this.formSubmit(event);
		    
    	this.textContactModal("Message sent, thank you.");
		
	}
    
    async formSubmit(event) {
		
		const requestOptions = {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/json' },
	        body: JSON.stringify({
				"custauth":global.config.auth.code,
				"custemail":event.target.custemail.value,
				"custsub":event.target.custsub.value,
				"custinfo":event.target.custinfo.value
				})
	    };
	    
	    const response = await fetch(global.config.auth.email, requestOptions)
	    		    
		const data = await response.json();
		
		return data;

	}
	
	contentBlock() {
			
		return(
			
			<div className="contact">		
			
				<h1 className="font-weight-light">Contact</h1>
				
		      <div className="container dt-container">
		        <div className="row align-items-center">
		        		        
		        	<h2>Get in touch</h2>
		        	<div className="col-xl-12 col-lg-12">
			        	<p>
			        		Contact me using one of the options below.
			        	</p>        
		        	</div>
		        	       
		          	<div className="col-xl-12 col-lg-12 mb-4">
		          		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-telephone" viewBox="0 0 20 20">
						  <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"/>
						</svg>
		          		&nbsp;<a href="tel:+5027273201">502-727-3201</a>
		          	</div>
		          	<div className="col-xl-12 col-lg-12 mb-4">
		          		<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-envelope" viewBox="0 0 20 20">
						  <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
						</svg>
		          		&nbsp;<a href="mailto:dptaylormft@gmail.com">dptaylormft@gmail.com</a>
	          		</div>     	
		          	<div className="col-xl-12 col-lg-12 mb-4">
			          	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 20 20">
						  <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"/>
						</svg>
		          		2620 Bardstown Road Suite 4 Louisville, KY 40205
		          	</div>

				<div className="col-lg-12">
			    <APIProvider apiKey={apiKey}>
			      <div style={{ height: '500px', width: '100%' }}>
			        {/* The Map component displays the map */}
			        <Map
			          defaultCenter={position}
			          defaultZoom={13}
			          mapId="80e7842ff8ce0d0cb59d059f " // Using a Map ID allows for custom styling
			          gestureHandling={'greedy'}
			        >
			          {/* AdvancedMarker adds a marker at the specified position */}
			          <AdvancedMarker position={position} />
			        </Map>
			      </div>
			    </APIProvider>
	          	</div>     
		          
		        </div>
		      </div>
		      
		      <div className="col-lg-12">  
		      <br />
		      </div>
		      		          	
		          
			</div>
		);
			
	}

    render() {
	
		document.title = global.config.pageTitles.contact + 
					global.config.pageTitles.seperator +
					global.config.pageTitles.title;	
			
    	return (
         	this.contentBlock()
    	);
    	
    }

}

export default Contact;


